import { Menu, Transition } from '@headlessui/react';
import { Auth } from 'aws-amplify';
import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { authState } from './state/atoms';
import { classNames } from './utils/formatters';

export default function Header() {
  const navigate = useNavigate();
  const [auth, setAuth]: [any, any] = useRecoilState(authState);

  const userLetter = auth && auth.attributes.email.charAt(0).toUpperCase();

  /* This example requires Tailwind CSS v2.0+ */
  const navigation: any = [
    {
      name: 'View Funds',
      onClick: () => {
        navigate('/funds');
      },
    },
  ];

  // user menu
  const userNavigation = [
    {
      name: 'Sign out',
      onClick: useCallback(async () => {
        await Auth.signOut();
        setAuth(null);
        navigate('/');
      }, [navigate, setAuth]),
    },
  ];

  return (
    <header className="bg-gradient-to-b from-slate-800 to-slate-900 border-b border-gray-700">
      <nav
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
        aria-label="Top"
      >
        <div className="w-full py-6 flex items-center justify-between border-b border-indigo-500 lg:border-none">
          <div className="flex items-center">
            <button onClick={() => navigate('/')}>
              <img
                src={'/assets/mvsf-logo-white.svg'}
                className="w-[300px] m-auto"
                alt="Mass Violence Survivors Fund Logo"
              />
            </button>
            <div className="hidden ml-10 space-x-8 lg:block">
              {auth
                ? navigation.map((link: any) => (
                    <button
                      key={link.name}
                      onClick={link.onClick}
                      className="text-base font-medium tracking-wide text-white uppercase hover:text-indigo-50"
                    >
                      {link.name}
                    </button>
                  ))
                : null}
            </div>
          </div>
          <div className="ml-10 space-x-4">
            {auth ? (
              <Menu
                as="div"
                className="ml-3 relative"
              >
                <div>
                  <Menu.Button className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                    <span className="sr-only">Open user menu</span>
                    <div className="inline-block h-10 w-10 rounded-full text-white bg-gradient-to-b from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-2xl font-semibold leading-9 shadow-sm">
                      {userLetter}
                    </div>
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {userNavigation.map((item) => (
                      <Menu.Item key={item.name}>
                        {({ active }: any) => (
                          <button
                            onClick={item.onClick}
                            className={classNames(
                              active ? 'bg-gray-100' : '',
                              'w-full text-left block px-4 py-2 text-gray-700',
                            )}
                          >
                            {item.name}
                          </button>
                        )}
                      </Menu.Item>
                    ))}
                  </Menu.Items>
                </Transition>
              </Menu>
            ) : (
              <button
                onClick={() => navigate('/')}
                disabled={true}
                className="inline-block bg-gradient-to-b from-green-600 to-green-700 hover:from-green-700 hover:to-green-800  py-2 px-4 border border-transparent rounded-md text-base font-medium text-white hover:bg-opacity-75 disabled:opacity-75 disabled:from-gray-200 disabled:to-gray-300 disabled:border-gray-300 disabled:cursor-not-allowed transition-all duration-300 ease-in-out"
              >
                Sign in
              </button>
            )}
          </div>
        </div>
        <div className="py-4 flex flex-wrap justify-center space-x-6 lg:hidden">
          {navigation.map((link: any) => (
            <a
              key={link.name}
              href={link.href}
              className="text-base font-medium text-white hover:text-indigo-50"
            >
              {link.name}
            </a>
          ))}
        </div>
      </nav>
      {process.env.REACT_APP_ENVIRONMENT !== 'prod' && (
        <div className="bg-red-200 text-red-700 p-2 text-center text-sm leading-6 font-semibold tracking-widest uppercase">
          Your Environment: {process.env.REACT_APP_ENVIRONMENT}
        </div>
      )}
    </header>
  );
}
